<ng-container *ngIf="headerLinksNavNode$ | async as headerLinksNavNode">
  <ng-container *ngIf="isDealerSelector">
    <cx-generic-link (click)="goToDealer()" [url]="headerLinksNavNode.url">{{
      headerLinksNavNode.title
    }}</cx-generic-link>
  </ng-container>
  <div class="header-links-container js-header-top-menu" *ngIf="isHeaderLinks">
    <div [ngClass]="styleClass$ | async">
      <ng-container *ngFor="let headerEntry of shimanoHeaderNavNode.entries; let i = index">
        <nav>
          <cx-generic-link
            *ngIf="headerEntry"
            [ngClass]="styleClass$ | async"
            [url]="headerEntry.url"
            [style]="headerEntry.styleAttributes"
            >{{ headerEntry.linkName }}</cx-generic-link
          >
        </nav>
      </ng-container>
    </div>
  </div>
  <app-my-account *ngIf="isMyAccount" [myAccountNavNode]="headerLinksNavNode"> </app-my-account>
</ng-container>
